import { AdminLayout } from '@/components/AdminLayout';
import { ModalRenderer } from '@/components/ModalRenderer';
import { Separator } from '@/components/ui/separator';
import { ModalProvider } from '@/contexts/ModalContext';
import React from 'react';

function AdminLayoutContent({
  heading,
  breadCrumbComponent,
  leftComponent,
  rightComponent,
}: {
  heading: string;
  breadCrumbComponent: React.ReactNode;
  leftComponent: React.ReactNode;
  rightComponent: React.ReactNode;
}) {
  return (
    <div className="h-full max-w-[1440px] mx-auto">
      <div className="h-full flex flex-col gap-10">
        <div className="">{breadCrumbComponent}</div>
        <div className="flex-1 grid grid-cols-[350px_1fr] gap-4">
          <div className="px-4 overflow-y-auto bg-white border-r border-gray-200">
            <div className="text-center">
              <h2 className="text-lg font-bold text-gray-900">{heading}</h2>
            </div>
            <Separator className="my-5" />
            <div className="p-2 text-center">{leftComponent}</div>
          </div>
          <div className="px-4 bg-white">{rightComponent}</div>
        </div>
      </div>
    </div>
  );
}

export default function AdminQuestionnaireLayout({
  heading,
  breadCrumbComponent,
  leftComponent,
  rightComponent,
}: {
  heading: string;
  breadCrumbComponent: React.ReactNode;
  leftComponent: React.ReactNode;
  rightComponent: React.ReactNode;
}) {
  return (
    <AdminLayout title='Applications' breadcrumbs={[]} showBreadcrumbs={false}>
      <ModalProvider>
        <AdminLayoutContent
          heading={heading}
          breadCrumbComponent={breadCrumbComponent}
          leftComponent={leftComponent}
          rightComponent={rightComponent}
        />
        <ModalRenderer />
      </ModalProvider>
    </AdminLayout>
  );
}
